import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

import { takeUntil, tap } from 'rxjs';
import {
  OrganizationsService,
  UsersService,
  ZonesService,
} from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { DateTimeService } from 'src/app/core/services/date-time.service';
import { AppDomService } from 'src/app/core/services/dom.service';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { AddUserMobileDialogComponent } from '../../users/user-form/add-user-mobile-dialog/add-user-mobile-dialog.component';
import { CreateUserInfoCommand } from './../../../../core/api/models/create-user-info-command';
import { AuthenticatedMobileService } from './../../../../core/api/services/authenticated-mobile.service';
import { DialogService } from './../../../../core/services/dialog.service';
import { UserFormComponent } from './../../users/user-form/user-form.component';

@Component({
  selector: 'app-organization-admin-user-form',
  templateUrl: './organization-admin-user-form.component.html',
  styleUrls: ['./organization-admin-user-form.component.scss'],
  imports: [BaseFormModule],
})
export class OrganizationAdminUserFormComponent
  extends UserFormComponent
  implements OnInit
{
  @Input() model: CreateUserInfoCommand;
  @Output('userForm') output_userForm = new EventEmitter<FormGroup>();
  @Output('mobilesForm') output_mobilesForm = new EventEmitter<FormGroup[]>();

  constructor(
    protected currentService: UsersService,
    protected dialogService: DialogService,
    protected zoneService: ZonesService,
    public organizationService: OrganizationsService,
    public authenticatedMobileService: AuthenticatedMobileService,
    protected translate: TranslateService
  ) {
    super(
      currentService,
      dialogService,
      zoneService,
      organizationService,
      authenticatedMobileService,
      translate
    );
  }

  ngOnInit() {
    super.ngOnInit();
    this.pageVocabs = 'pages.users.form.';
    this.fields = 'pages.users.form.fields.';
  }

  ngOnChanges() {
    this.selectedState = null;
    this.isRefreshForm = true;
    this.setComponentsConfig();
  }

  initForm(): void {
    super.initForm();
    this.form.get('organizationId').clearValidators();
    this.form.get('organizationId').updateValueAndValidity();
    // this.form.get('mobile').setValidators(Validator.mobile);
  }

  setComponentsConfig() {
    try {
      this.dateTimeConfig = {
        dateLabel: 'common.expireDate',
        timeLabel: 'common.expireTime',
        dateFormControl: this.form?.get('expireDate') as FormControl,
        timeFormControl: this.form?.get('expireTime') as FormControl,
        minDateType: 'today',
        isDefaultValue: false,
        isConvertToIsoString: false,
        responsiveClassName: 'md:tw-w-1/2',
        dateTimeValue: DateTimeService.combineDateTimeToUTC(
          DateTimeService.getAYearLaterToIsoString(),
          '00:00'
        ),
        isEditMode: this.formPageConfig.isEditMode,
      };
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  override onOpenAddUserMobileDialog() {
    this.unSubs();
    const modalResult = this.dialogService.openModal({
      component: AddUserMobileDialogComponent,
    });
    modalResult
      .afterClosed()
      .pipe(
        takeUntil(this.onDestroy$),
        tap(() => {
          AppDomService.removeModalScrollClassFromHtml();
        })
      )
      .subscribe((mobileNumber) => {
        if (!mobileNumber) return;
        this.mobile = mobileNumber;

        if (!this.formPageConfig?.isEditMode) {
          this.onAddMobile();
          this.emitForm();
        } else this.onAddOrDeleteMobile();
      });
  }

  override onRemoveMobile(index: number) {
    try {
      this.newMobiles.splice(index, 1);
      this.mobilesForm.splice(index, 1);

      this.emitForm();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  emitForm() {
    this.model.mobile = this.newMobiles;
    this.output_userForm.emit(this.form);
    this.output_mobilesForm.emit(this.mobilesForm);
  }

}
